// v1/mydriver-supply/tsps/{{tsp_id}}/notes
import { goOrangeAxios } from './axios';

export const getNotes = async function (tspId) {
    return goOrangeAxios.get(`v1/mydriver-supply/tsps/${tspId}/notes`);
};
export const addNote = async function (tspId, request) {
    return goOrangeAxios.post(`/v1/mydriver-supply/tsps/${tspId}/notes`, request);
};